<template>
  <div class="order-shipping-address">
    <v-radio-group v-model="localValue.shipping.address.address">
      <template v-for="(a, j) in shippingAddresses">
        <v-row :key="j">
          <v-col
            cols="1"
            class="d-flex"
          >
            <v-radio
              :value="a"
              class="align-self-center"
            />
          </v-col>

          <v-col>
            <v-list
              two-line
              min-width="100%"
            >
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ a.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ formatAddressText(a) }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn icon small>
                    <v-icon small>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </template>

      <v-row>
        <v-col offset="1">
          <v-list>
            <v-list-item-action>
              <v-btn
                text
                color="primary"
                :disabled="_.get(company, 'shippingSameAsBilling', false)"
                @click="$emit('new-address')"
              >
                <v-icon left>
                  mdi-plus
                </v-icon>
                New Address
              </v-btn>
            </v-list-item-action>
          </v-list>
        </v-col>
      </v-row>
    </v-radio-group>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ModelableMixin from '../../../../mixins/modelable';
import AddressFormatterMixin from '../../../../../mixins/address-formatter';

export default {
  name: 'Address',

  mixins: [
    ModelableMixin,
    AddressFormatterMixin,
  ],

  computed: {
    ...mapGetters('company', {
      findCompany: 'find',
      getCompany: 'get',
    }),

    shippingAddresses() {
      return _.get(this.company,
        _.get(this.company, 'shippingSameAsBilling') ? 'billingAddresses' : 'shippingAddresses',
        []);
    },

    company() {
      return _.get(this.findCompany({ companyOwner: _.get(this, 'user._id') }), 'data.0', this.data);
    },
  },

  async mounted() {
    await this.fetchCompanies();
  },

  methods: {
    ...mapActions('company', {
      fetchCompanies: 'find',
    }),
  },
};
</script>

<style scoped>

</style>
